export default __webpack_public_path__ + "static/media/JAVIERA WARNIER.ce69a35a.jpeg";